<!-- Chat Section -->
<div class="p-2 mb-5 mt-1">
  <div class="rounded-lg border-0 p-1">
    <div class="rounded-lg">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="nav-item">
              <a class="text-white text-decoration-none text-x nav-link" href="#">
                <i class='bx bxs-user-circle fs-3 text-primary me-2 cursor-pointer'></i>
                <p class="text-x mb-0 text-dark fw-bold">Live Chat with Admin</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="shadow position-relative p-3 card-body-h rounded-lg border table-border-color">
      <div class="bg-light rounded-5 m-3 position-absolute top-0 start-0 end-0 bottom-0 z-0"></div>
      <div class="position-relative h-100 d-flex flex-column justify-content-between ">
        <div class="p-3 scroll-container-crm" ref="scrollContainer">
          <div v-if="Object.keys(lead_messages).length === 0" class="text-center text-muted small">
            No messages yet. Start the chat below.
          </div>
          <div v-for="(messages, date) in lead_messages" :key="date">
            <div class="text-center text-muted text-xs fw-bold my-2">{{ date }}</div>
            <div v-for="msg in messages" :key="msg.id"
                class="mb-3 d-flex flex-column"
                :class="{ 'align-items-end': msg.is_superuser, 'align-items-start': !msg.is_superuser }">

              <span class="text-xxs fw-semibold mb-1"
                    :class="{ 'text-end': msg.is_superuser, 'text-start': !msg.is_superuser }">
                {{ msg.is_superuser ? 'Admin' : 'You' }}
              </span>

                <div v-if="msg.message || msg.attachment_url"
                    :class="[
                      'message-bubble',
                      (is_image(msg.attachment_name) && !msg.message)
                        ? 'image-only'
                        : 'p-3 rounded-pill shadow-sm text-xxs',
                      (is_image(msg.attachment_name) && !msg.message)
                        ? ''   /* nothing when image-only */
                        : (msg.is_superuser
                              ? 'primary-color text-dark'
                              : 'custom-header text-white')
                    ]">
                <span v-if="msg.message">{{ msg.message }}</span>
                <template v-if="msg.attachment_url">
                <br v-if="msg.message">

                <img  v-if="is_image(msg.attachment_name)"
                      :src="msg.attachment_url"
                      class="bubble-img"
                      @click.prevent="open_attachment(msg)"/>

                <a   v-else
                    href="#"
                    data-bs-toggle="modal" data-bs-target="#attachment_viewer"
                    @click.prevent="open_attachment(msg)"
                    :class="msg.is_superuser ? 'text-dark' : 'text-white'"
                    class="text-decoration-underline d-inline-block mt-1">
                    {{ msg.attachment_name }}
                </a>
              </template>
              </div>
              <small class="text-muted mt-1 text-xxs fw-bold"
                    :class="{ 'text-end': msg.is_superuser, 'text-start': !msg.is_superuser }">
                {{ msg.time }}
              </small>
            </div>
          </div>
        </div>
          <div class="position-relative p-2 mb-0">
      <!-- Text Input -->
      <input
        type="text"
        class="form-control rounded-pill p-3 text-xs border border-1 border-black"
        v-model="lead_message"
        placeholder="Type your message..."
        @keyup.enter="send_lead_message"
      />

      <!-- Icons inside the input -->
      <div class="position-absolute end-0 top-50 translate-middle-y d-flex gap-2 me-3">
        <!-- Attachment Icon -->
        <i class="btn-sm btn-primary-dark text-dark rounded-lg bi bi-paperclip fs-6 mt-1" role="button" @click="$refs.file_input.click()"></i>

        <!-- Send Icon -->
        <span class="btn-sm btn-primary-dark text-dark rounded-lg fs-6 mt-1" role="button" @click="send_lead_message">➤</span>
      </div>

      <!-- Hidden file input -->
      <input
        type="file"
        ref="file_input"
        class="d-none"
        @change="handle_file_change"
      />
      </div>
      </div>
    </div>
  </div>
</div>

<teleport to="body">
  <div class="modal fade" id="attachment_viewer" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0">{{ viewer_name }}</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body p-0 overflow-auto doc-viewer-body">

          <img v-if="is_image(viewer_name)"
              :src="viewer_url"
              class="img-fluid w-100 rounded-0" />

          <iframe v-else
            :src="viewer_url"
            class="w-100 h-100 border-0 file-viewer-frame">
          </iframe>
        </div>

      </div>
    </div>
  </div>
</teleport>

